import React from 'react';
import { Map as LeafletMap, TileLayer, Marker, Tooltip } from 'react-leaflet';
import styles from './Map.scss';
import { any, arrayOf, shape, number, func, bool, string } from 'prop-types';
import { latLngBounds, latLng, point } from 'leaflet';

const DEFAULT_VIEWPORT = {
  center: [52.114503, 19.423561],
  zoom: 6,
};

const getCenterAndZoom = markers => {
  if (markers.length !== 1) return DEFAULT_VIEWPORT;
  return { center: [markers[0].lat, markers[0].lng], zoom: 15 };
};

const getBounds = markers => {
  if (markers.length < 2) return null;
  return latLngBounds(markers.map(m => latLng(m.lat, m.lng)));
};

const Map = ({ markers, onMarkerMoved, readonly }) => {
  const { center, zoom } = getCenterAndZoom(markers);
  const bounds = getBounds(markers);
  return (
    <LeafletMap
      center={center}
      maxZoom={19}
      zoom={zoom}
      bounds={bounds}
      boundsOptions={{ padding: point(50, 50) }}
      className={styles}>
      <TileLayer
        attribution={'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}
        url={'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'}
      />
      {
        markers.map(({ id, lat, lng, title }) => (
          <Marker
            key={id}
            draggable={!readonly}
            riseOnHover
            autoPan
            position={[lat, lng]}
            onmoveend={e => { if (onMarkerMoved) onMarkerMoved({ id, ...e.target.getLatLng() }); }}
          >
            <Tooltip permanent>{title}</Tooltip>
          </Marker>))
      }
    </LeafletMap>
  );
};

Map.defaultProps = {
  markers: [],
  onMarkerMoved: null,
  readonly: false,
};

Map.propTypes = {
  markers: arrayOf(shape({
    id: any.isRequired,
    lat: number.isRequired,
    lng: number.isRequired,
    title: string.isRequired,
  })),
  onMarkerMoved: func,
  readonly: bool,
};

export default Map;



// WEBPACK FOOTER //
// ./src/components/map/Map.js